import { Component, Prop, Vue } from 'vue-property-decorator';

interface MdRadioData {
    text: string;
    value: number;
}

@Component({
    computed: {
        content: {
            get() {
                return this.$props.value;
            },
            set(value) {
                const newValue = isNaN(value) ? value : Number(value);
                this.$emit('input', newValue);
                this.$data.dirty = true;
                (this.$refs.radio as any).classList.remove('error');
            }
        },
        $error() {
            return this.$props.required && this.$data.dirty && this.$props.value == null;
        }
    }
})
export default class MdRadio extends Vue {
    @Prop() value: any;
    @Prop() options!: any | MdRadioData[];
    @Prop() name!: string;
    @Prop() label?: string;
    @Prop() required?: string;
    @Prop() disabled?: boolean;
    dirty: boolean = false;

    $refs!: {
        radio: HTMLFormElement
    };
}
